<div id="dynamicContainer" class="m-2 h-100"></div> <!-- DynamicContent should be placed on top !-->

<a class="btn btnRight" (click)="panelState.toggleState('right')"><i class="fa fa-list-ul"></i></a>
